var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 44C8.5 35.1634 15.6634 28 24.5 28C33.3366 28 40.5 35.1634 40.5 44H36.5C36.5 37.3726 31.1274 32 24.5 32C17.8726 32 12.5 37.3726 12.5 44H8.5ZM24.5 26C17.87 26 12.5 20.63 12.5 14C12.5 7.37 17.87 2 24.5 2C31.13 2 36.5 7.37 36.5 14C36.5 20.63 31.13 26 24.5 26ZM24.5 22C28.92 22 32.5 18.42 32.5 14C32.5 9.58 28.92 6 24.5 6C20.08 6 16.5 9.58 16.5 14C16.5 18.42 20.08 22 24.5 22Z",
    fill: "#F4C708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.65a45df500e3d93a6fc97fdfe876d3ae.svg";
export { ForwardRef as ReactComponent };